<label [class.isInvalid]="getIsInvalid()">
  <vc-checkbox-input [(ngModel)]="value" (ngModelChange)="onValueChange()" [isInvalid]="getIsInvalid()"></vc-checkbox-input>

  <div class="label-text">
    {{ label }}
    <ng-content></ng-content>
  </div>
</label>
